import Shape from "./Shape";

export default class Crop extends Shape {

  static createWithDefaults(scale) {
    const x = 10 / scale;
    const y = 10 / scale;
    const width = 100 / scale;
    const height = 100 / scale;
    return new Crop(x, y, width, height);
  }

}
